import { render, staticRenderFns } from "./Textos.vue?vue&type=template&id=1c0a4040&"
import script from "./Textos.vue?vue&type=script&lang=js&"
export * from "./Textos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports